module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-desktop-06438a8e5455242ba35ff30f1975aa50.jpg";